import React from "react";
import PWAInstallButton from "../../PWAInstallButton";


const Footer = () => {
    return (
        <>
            <footer id="foot" className="footer position-relative">
                <div className="container">
                    <div className="row gy-5">

                        {/* Left Column - Brand Info */}
                        <div className="col-lg-4">
                            <div className="footer-brand">
                                <a href="/" className="logo d-flex align-items-center mb-3">
                                    <span className="sitename">PQHub</span>
                                </a>
                                <p className="tagline">Your ultimate past questions and learning platform.</p>

                                {/* PWA Install Button in Footer */}
                                <div className="mt-4">
                                    <PWAInstallButton />
                                </div>

                               
                            </div>
                        </div>

                        {/* Middle Columns - Quick Links */}
                        <div className="col-lg-8">
                            <div className="footer-links-grid">
                                <div className="row">
                                    <div className="col-6 col-md-4">
                                        <h5>Platform</h5>
                                        <ul className="list-unstyled">
                                            <li><a href="/">Home</a></li>
                                            <li><a href="/about">About Us</a></li>
                                            <li><a href="/questions">Questions</a></li>
                                            <li><a href="/contact">Contact</a></li>
                                        </ul>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <h5>Resources</h5>
                                        <ul className="list-unstyled">
                                            <li><a href="/questions?category=mathematics">Mathematics</a></li>
                                            <li><a href="/questions?category=science">Science</a></li>
                                            <li><a href="/questions?category=english">English</a></li>
                                            <li><a href="/questions?category=ict">ICT</a></li>
                                        </ul>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <h5>Support</h5>
                                        <ul className="list-unstyled">
                                            {/* <li><a href="/help">Help Center</a></li>
                                            <li><a href="/faq">FAQ</a></li> */}
                                            <li><a href="/privacy">Privacy Policy</a></li>
                                            <li><a href="/terms">Terms of Service</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="footer-bottom-content">
                                    <p className="mb-0">© <span className="sitename">PQHub</span>. All rights reserved.</p>
                                    <div className="credits">
                                        Designed by <a href="https://eddcodesgh.com/"  target="_blank">Pegcodes Technologies</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </footer>
        </>
    )
}

export default Footer;